import React from "react"
import {Box, Typography, useTheme} from "@mui/material"

const LegendRow = ({datasets = []}) => {
    const theme = useTheme()
    const textColor = theme.EVENTSANDBARCHART?.legend?.textColor

    return (
        <Box
            sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                mt: 3,
                justifyContent: "flex-start",
            }}
        >
            {datasets
                .filter((ds) => ds.data?.some((v) => Number(v) > 0))
                .map((ds) => (
                    <Box
                        key={ds.label}
                        sx={{display: "flex", alignItems: "center", gap: 0.75}}
                    >
                        <Box
                            sx={{
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                backgroundColor: Array.isArray(ds.backgroundColor)
                                    ? ds.backgroundColor[0]
                                    : ds.backgroundColor,
                            }}
                        />
                        <Typography variant="caption" sx={{color: textColor}}>
                            {ds.label}
                        </Typography>
                    </Box>
                ))}
        </Box>
    )
}

export default LegendRow
